import Vue from 'vue'
import Router from 'vue-router'
import store from '../_vuex/store'
import Login from '@/page/Login'
import PrivacyServiceAgreement from '@/page/privacyServiceAgreement'
import LogChangePassword from '@/page/LogChangePassword'
import ChangePassword from '@/page/ChangePassword'
import Register from '@/page/Register'
import ResourceCenter from '@/page/ResourceCenter'
import Support from '@/page/Support'
import DevelopCenter from '@/page/DevelopCenter'
import DocumentCenter from '@/page/DocumentCenter'
import SboxEverment from '@/page/SboxEverment'

//register
import FirstStep from '@/components/_register/FirstStep'
import SecondStep from '@/components/_register/SecondStep'
import ThirdStep from '@/components/_register/ThirdStep'

//developCenter
import DevelopNews from '@/components/_developCenter/DevelopNews'
import UserNews from '@/components/_developCenter/UserNews'
import StationNotice from '@/components/_developCenter/StationNotice'
import InvoiceCheck from '@/components/_developCenter/InvoiceCheck'
import MockTool from '@/components/_developCenter/MockTool'



//InvoiceCheck 子功能页面
import InvoiceChange from '@/page/InvoiceChange'
import Risk from '@/page/Risk'
import BatchData from '@/page/BatchData'

// 手机验证码登录页
import LoginByPhone from '@/page/LoginByPhone'

// apiKey管理页面
import ApiCenter from '@/page/ApiCenter.vue'

Vue.use(Router)

let router = new Router({
	routes: [
		{ path: '/login', name: 'login', component: Login },
		{ path: '/login/phone', name: 'loginByPhone', component: LoginByPhone },
		{ path: '/PrivacyServiceAgreement', name: 'PrivacyServiceAgreement', component: PrivacyServiceAgreement },

		{ path: '/logChangePassword', name: 'LogChangePassword', component: LogChangePassword },
		{ path: '/documentCenter', name: 'documentCenter', component: DocumentCenter },//文档中心
		{ path: '/apiCenter', name: 'apiCenter', component: ApiCenter },//文档中心
		{
			path: '/register', name: 'register', component: Register,
			children: [
				{ path: 'firstStep', name: 'firstStep', component: FirstStep },//注册第二步
				{ path: 'secondStep', name: 'secondStep', component: SecondStep },//注册第三步
				{ path: 'thirdStep', name: 'thirdStep', component: ThirdStep },//注册第一步
				//默认路由
				{ path: '/', redirect: 'secondStep' }
			]
		},
		{ path: '/resourceCenter', name: 'resourceCenter', component: ResourceCenter },
		{ path: '/changePassword', name: 'changePassword', component: ChangePassword },
		{ path: '/sboxEverment', name: 'sboxEverment', component: SboxEverment },
		{ path: '/support', name: 'support', component: Support },
		{ path: '/invoiceChange', name: 'invoiceChange', component: InvoiceChange },
		{ path: '/risk', name: 'risk', component: Risk },
		{ path: '/batchData', name: 'batchData', component: BatchData },
		{
			path: '/developCenter', name: 'developCenter', component: DevelopCenter,   //开发者中心
			children: [
				{ path: 'developNews', name: 'developNews', component: DevelopNews }, //开发者信息
				{ path: 'userNews', name: 'userNews', component: UserNews },//联系人信息
				{ path: 'stationNotice', name: 'stationNotice', component: StationNotice },//站内通知					        
				{ path: 'invoiceCheck', name: 'invoiceCheck', component: InvoiceCheck }, // 发票核验
				{ path: 'mockTool', name: 'mockTool', component: MockTool }, // 埋数工具
				//默认路由
				{ path: '/', redirect: 'developNews' }
			]
		},
		{ path: '/', redirect: "/login" },
		{ path: '*', redirect: "/login" }
	],
})
//监听浏览器url变化 包括前进或者后退
router.afterEach((to, from) => {
	//当后退或者前进到登录页面时，退出登录
	if (to.name == 'login') {
		store.dispatch('changeUserName', '');
		sessionStorage.setItem("passWord", '')
		sessionStorage.setItem("devId", '')
		sessionStorage.setItem("certificate", '')
	}
	// 生产环境如果想通过路由进入的话，跳转到主页
	if (location.href.includes('open.yinshuitong.com') &&
		(to.name.includes('invoiceChange')
			|| to.name.includes('risk')
			|| to.name.includes('batchData')
			|| to.name.includes('invoiceCheck')
			|| to.name.includes('mockTool'))) {
		router.push('/developCenter/developNews')
	}
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js